import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 选择通讯录
 */
export type FabricUtilsGetContactOptions = {
  /**
   * 单选还是多选. 默认只允许选择一个联系人
   * @default false
   */
  multi: boolean;
};

/**
 * 返回通讯录列表
 */
export type FabricUtilsGetContactsCallbackData = {
  contacts: Array<{
    mobile: string[];
    contactName: string;
  }>;
};

/**
 * 选择通讯录, 会弹出通讯录界面, 让用户选择单个联系人
 */
export type FabricUtilsGetContactApi = (
  options: FabricUtilsGetContactOptions
) => Promise<FabricUtilsGetContactsCallbackData>;

/**
 * 获取通讯录列表, 异步调用
 */
export type FabricUtilsGetContactsApi =
  () => Promise<FabricUtilsGetContactsCallbackData>;

/**
 * 检查当前是否有权限获取通讯录信息, 业务上可能在有权限再去获取, 避免权限弹窗干扰.
 * 同步方法
 */
export const getContactsPermissionStatus = () => {
  const result = core.call<'fabric_utils.getContactsPermissionStatus', boolean>(
    'fabric_utils.getContactsPermissionStatus'
  );
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
/**
 * 获取通讯录列表, 异步调用
 * 1. 如果弹出权限被用户强制关闭, 或者用户点了拒绝, 或者在设置里面禁用了, 返回错误code:`contact_permission_disallow`
 */
export const getContacts: FabricUtilsGetContactsApi = () => {
  return new Promise<FabricUtilsGetContactsCallbackData>((resolve, reject) => {
    core.call<
      'fabric_utils.getContacts',
      null,
      FabricUtilsGetContactsCallbackData
    >('fabric_utils.getContacts', null, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
/**
 * 选择通讯录, 会弹出通讯录界面, 让用户选择单个联系人
 * 1. 如果弹出权限被用户强制关闭, 或者用户点了拒绝, 或者在设置里面禁用了, 返回错误code:`contact_permission_disallow`
 */
export const getContact: FabricUtilsGetContactApi = (
  options: FabricUtilsGetContactOptions = { multi: false }
) => {
  return new Promise<FabricUtilsGetContactsCallbackData>((resolve, reject) => {
    core.call<
      'fabric_utils.getContact',
      FabricUtilsGetContactOptions,
      FabricUtilsGetContactsCallbackData
    >('fabric_utils.getContact', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
